import { IRtcStream } from "@formant/core/model/IRtcStream";
import { RtcStreamType } from "@formant/core/model/RtcStreamType";

export function encodeStreamId({
    entityId,
    streamName,
    streamType,
}: IRtcStream): string {
    return `${entityId}.${streamName}.${streamType}`;
}

export function decodeStreamId(streamId: string): IRtcStream {
    const decoded = streamId.split(".");
    return {
        entityId: `${decoded[0]}`,
        streamName: `${decoded[1]}`,
        streamType: `${decoded[2]}` as RtcStreamType,
    };
}
